<template>
  <a class="btn btn-primary" @click="$emit('handle')">確認</a>
</template>

<script type="text/javascript">
export default {
  
}
</script>
